import { render, staticRenderFns } from "./MergeEventsDialog.vue?vue&type=template&id=332024f1&"
import script from "./MergeEventsDialog.vue?vue&type=script&lang=js&"
export * from "./MergeEventsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./MergeEventsDialog.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('332024f1')) {
      api.createRecord('332024f1', component.options)
    } else {
      api.reload('332024f1', component.options)
    }
    module.hot.accept("./MergeEventsDialog.vue?vue&type=template&id=332024f1&", function () {
      api.rerender('332024f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/StationPlaceEvents/MergeEventsDialog.vue"
export default component.exports